import React, { useEffect, useState, useContext } from "react";
import { toast } from "react-toastify";
import {
    getShareHolders,
    deleteShareHolder,
    updateShareHolder,
    createShareList,
    getBankBalance
} from "../../../Utility/Api";
import { Deletemodel } from "../../Common/Functions";
import AddShareHolderForm from "./form/AddShareHolderForm";
import { WarehouseContext } from "../../../Utility/UserContext";

const ShareHolderList = () => {
    const { showLoader, hideLoader, shopItem, UserItem } = useContext(WarehouseContext);

    const [data, setData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [confirmModal, setConfirmModal] = useState(false);
    const [modalType, setModalType] = useState("");
    const [selectedData, setSelectedData] = useState(null);
    const [paymentModal, setPaymentModal] = useState(false);
    const [selectedID, setSelectedID] = useState(null);
    const [paymentData, setPaymentData] = useState({
        total_profit: "",
        distributed_amount: "",
        profit_month: "",
        // remarks: "",
    });
    const [shareResult, setShareResult] = useState(null);



    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        showLoader();
        try {
            const params = {
                shop_id: shopItem?.shop_id || "",
            };
            const res = await getShareHolders(params);
            setData(res?.data?.data || []);
        } catch {
            toast.error("Failed to load shareholders");
        } finally {
            hideLoader();
        }
    };


    const openAddEditModal = (row = null) => {
        setSelectedData(row);
        setShowModal(true);
    };

    const openStatusModal = (id) => {
        setSelectedID(id);
        setModalType("status");
        setConfirmModal(true);
    };

    const openDeleteModal = (id) => {
        setSelectedID(id);
        setModalType("delete");
        setConfirmModal(true);
    };


    const handleStatusToggle = async () => {
        try {
            showLoader();
            const current = data.find(i => i.id === selectedID);
            const newStatus = current.status === "0" ? "1" : "0";

            await updateShareHolder(selectedID, {
                ...current,
                status: newStatus,
            });

            toast.success("Status updated");
            fetchData();
        } catch {
            toast.error("Failed to update status");
        } finally {
            hideLoader();
            setConfirmModal(false);
        }
    };


    const handleDelete = async () => {
        try {
            showLoader();
            await deleteShareHolder(selectedID);
            toast.success("Shareholder deleted");
            fetchData();
        } catch {
            toast.error("Delete failed");
        } finally {
            hideLoader();
            setConfirmModal(false);
        }
    };

    // const openPaymentModal = (shareholder) => {
    //     setSelectedData(shareholder);
    //     setPaymentModal(true);
    // };
    const openPaymentModal = async () => {
        setSelectedData();
        setPaymentModal(true);
        try {
            showLoader();
            const res = await getBankBalance(shopItem?.shop_id || "");
            if (res?.data?.status === "success") {
                setPaymentData(prev => ({ ...prev, total_profit: res.data.bank_balance }));
            }
        } catch (error) {
            toast.error("Failed to fetch bank balance");
        } finally {
            hideLoader();
        }
    };

    const handlePaymentSubmit1 = async () => {
        try {
            if (!paymentData.total_profit || !paymentData.distributed_amount) {
                toast.error("Please fill all required fields");
                return;
            }

            showLoader();
            const payload = {
                parent_id: selectedData.id,
                total_profit: paymentData.total_profit,
                distributed_amount: paymentData.distributed_amount,
                shop_id: shopItem?.shop_id || "",
                created_by: UserItem?.id || "1",
                remarks: paymentData.remarks || "",
            };

            await createShareList(payload);
            toast.success("Payment recorded successfully");
            setPaymentModal(false);
            setPaymentData({
                total_profit: "",
                distributed_amount: "",
                profit_month: "",
                remarks: "",
            });
        } catch (error) {
            toast.error(error?.message || "Failed to record payment");
        } finally {
            hideLoader();
        }
    };
    const handlePaymentSubmit = async () => {
        try {
            if (!paymentData.total_profit || !paymentData.distributed_amount || !paymentData.profit_month) {
                toast.error("Please fill all required fields");
                return;
            }

            if (parseFloat(paymentData.distributed_amount) > parseFloat(paymentData.total_profit)) {
                toast.error("Distributed amount cannot exceed total profit");
                return;
            }

            showLoader();

            const payload = {
                // parent_id: selectedData.id,
                total_profit: paymentData.total_profit,
                distributed_amount: paymentData.distributed_amount,
                profit_month: paymentData.profit_month,
                shop_id: shopItem?.shop_id || "",
                created_by: UserItem?.id || "1",
                // remarks: paymentData.remarks || "",
            };

            const res = await createShareList(payload);
            if (res?.data?.status === "success") {
                setShareResult(res.data);
                toast.success("Payment recorded successfully");
            }
            setPaymentModal(false);
            setPaymentData({
                total_profit: "",
                distributed_amount: "",
                profit_month: "",
                // remarks: "",
            });
        } catch (error) {
            const backendMsg =
                error?.response?.data?.message || "Failed to record payment";

            const required = error?.response?.data?.required_amount;
            const available = error?.response?.data?.available_balance;

            if (required && available) {
                toast.error(
                    `${backendMsg}. Required ₹${required}, Available ₹${available}`
                );
            } else {
                toast.error(backendMsg);
            }

        } finally {
            hideLoader();
        }
    };



    const buildTree = (shareholders, parentId = null, depth = 0) => {
        return shareholders
            .filter(sh => (parentId === null ? !sh.parent_id : String(sh.parent_id) === String(parentId)))
            .flatMap(sh => [
                { ...sh, depth },
                ...buildTree(shareholders, sh.id, depth + 1)
            ]);
    };

    const treeData = buildTree(data);

    return (
        <div className="page-content">
            {/* HEADER */}
            <div className="d-flex justify-content-start align-items-end">
                <h5 className="text-uppercase ">Share Holders</h5>
                </div>
                <div className="d-flex justify-content-end align-items-end gap-2 mb-2">
                <button
                    className="btn btn-primary btn-sm"
                    onClick={() => openAddEditModal()}
                >
                    {/* <i className="bi bi-plus-circle me-1"></i> */}
                    Add Share Holder
                </button>
                <button
                    type="button"
                    className="btn btn-sm btn-warning  me-2 px-4"
                    onClick={() => openPaymentModal()}
                    disabled={!data || data.length === 0}

                >
                    {/* <i className="bi bi-cash-coin"></i> */}
                    Pay
                </button>
            </div>

            {/* TABLE */}
            <div className="card shadow-sm">
                <div className="card-body table-responsive">
                    <table className="table table-bordered table-hover align-middle mb-0">
                        <thead className="table-light">
                            <tr>
                                <th>#</th>
                                <th>Name</th>
                                <th>Phone</th>
                                <th>Original Equity</th>
                                <th>Remaining (Own)</th>
                                <th>Capital</th>
                                <th>Status</th>
                                <th className="text-center">Actions</th>
                            </tr>
                        </thead>

                        <tbody>
                            {treeData.length === 0 && (
                                <tr>
                                    <td colSpan="8" className="text-center text-muted">
                                        No shareholders found
                                    </td>
                                </tr>
                            )}

                            {treeData.map((node, index) => (
                                <tr key={node.id} className={node.depth === 0 ? "table-primary fw-semibold" : ""}>
                                    <td className={node.depth > 0 ? "text-muted" : ""}>
                                        {node.depth === 0 ? index + 1 : "—"}
                                    </td>

                                    <td style={{ paddingLeft: `${node.depth * 30 + 10}px` }} className={node.depth > 0 ? "text-muted" : ""}>
                                        <div className="d-flex align-items-center gap-2">
                                            {node.depth > 0 && <span className="me-1">↳</span>}
                                            <i className={node.depth === 0 ? "bi bi-person-badge" : "bi bi-person"}></i>
                                            {node.name}
                                        </div>
                                    </td>

                                    <td className={node.depth > 0 ? "text-muted" : ""}>{node.phone}</td>

                                    <td>
                                        <span className={`badge ${node.depth === 0 ? "bg-info" : "bg-light text-dark"}`}>
                                            {node.equity}%
                                        </span>
                                    </td>

                                    <td>
                                        <span className={`badge ${node.depth === 0 ? "bg-warning text-dark" : "bg-light text-dark border"}`}>
                                            {node.own_equity ?? node.equity}%
                                        </span>
                                    </td>

                                    <td className={node.depth > 0 ? "text-muted" : ""}>
                                        {node.depth === 0 ? <strong>₹ {node.capital || "-"}</strong> : node.capital || "-"}
                                    </td>

                                    <td>
                                        <button
                                            className={`btn btn-sm ${node.status === "0"
                                                ? "btn-success"
                                                : "btn-outline-secondary"
                                                }`}
                                            onClick={() => openStatusModal(node.id)}
                                        >
                                            {node.status === "0" ? "Active" : "Inactive"}
                                        </button>
                                    </td>

                                    <td className="text-center">
                                        <img
                                            src='/assets/images/icons/edit.png'
                                            onClick={() => openAddEditModal(node)}
                                            height={node.depth === 0 ? "20px" : "15px"}
                                            alt="Edit"
                                            className='mx-2'
                                            style={{ cursor: 'pointer' }}
                                        />
                                        <img
                                            src='/assets/images/icons/delete.png'
                                            onClick={() => openDeleteModal(node.id)}
                                            height={node.depth === 0 ? "20px" : "15px"}
                                            alt="Delete"
                                            className='mx-2'
                                            style={{ cursor: 'pointer' }}
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* CONFIRM MODAL */}
            {confirmModal && (
                <Deletemodel
                    setShowModal={setConfirmModal}
                    handleDelete={
                        modalType === "status"
                            ? handleStatusToggle
                            : handleDelete
                    }
                    text={
                        modalType === "status"
                            ? "Change status of shareholder?"
                            : "Delete this shareholder?"
                    }
                />
            )}

            {paymentModal && (
                <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content" style={{ borderRadius: '12px' }}>
                            <div className="modal-header border-0 pb-0">
                                <div>
                                    <h5 className="modal-title fw-bold">
                                        <i className="bi bi-cash-stack me-2 text-success"></i>
                                        Payment Record
                                    </h5>
                                    <p className="text-muted mb-0 small">
                                        Recording payment for: <strong>{selectedData?.name ? selectedData.name :"All ShareHolder Distribution" }</strong>
                                    </p>
                                </div>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => {
                                        setPaymentModal(false);
                                        setPaymentData({
                                            total_profit: "",
                                            distributed_amount: "",
                                            profit_month: "",
                                            remarks: "",
                                        });
                                    }}
                                />
                            </div>
                            <div className="modal-body p-4">
                                <div className="mb-3">
                                    <label className="form-label small text-muted">
                                        <i className="bi bi-calendar-event me-1"></i>
                                        Profit Month <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="month"
                                        className="form-control form-control-lg"
                                        value={paymentData.profit_month}
                                        onChange={(e) => setPaymentData({
                                            ...paymentData,
                                            profit_month: e.target.value
                                        })}
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label small text-muted">
                                        <i className="bi bi-currency-rupee me-1"></i>
                                        Total Profit (Bank Balance) <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        className="form-control form-control-lg bg-light"
                                        placeholder="Enter total profit amount"
                                        value={paymentData.total_profit}
                                        readOnly
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label small text-muted">
                                        <i className="bi bi-cash me-1"></i>
                                        Distributed Amount <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        className="form-control form-control-lg"
                                        placeholder="Enter amount to distribute"
                                        value={paymentData.distributed_amount}
                                        onChange={(e) => setPaymentData({
                                            ...paymentData,
                                            distributed_amount: e.target.value
                                        })}
                                    />
                                    {paymentData.distributed_amount && data && data.filter(sh => sh.status === "0").length > 0 && (
                                        <div className="mt-3 bg-light p-3 rounded">
                                            <h6 className="fw-bold mb-2">Distribution Breakdown:</h6>
                                            <ul className="list-unstyled mb-0">
                                                {(() => {
                                                    const activeSh = data.filter(sh => sh.status === "0");
                                                    const totalOwnEquity = activeSh.reduce((sum, sh) => sum + parseFloat(sh.own_equity ?? sh.equity ?? 0), 0);
                                                    if (totalOwnEquity > 0) {
                                                        return activeSh.map(sh => {
                                                            const ownEq = parseFloat(sh.own_equity ?? sh.equity ?? 0);
                                                            if (ownEq <= 0) return null;
                                                            const share = (ownEq / totalOwnEquity) * parseFloat(paymentData.distributed_amount);
                                                            return (
                                                                <li key={sh.id} className="d-flex justify-content-between border-bottom py-1">
                                                                    <span>{sh.name} ({ownEq}%)</span>
                                                                    <strong>₹{share.toFixed(2)}</strong>
                                                                </li>
                                                            );
                                                        });
                                                    }
                                                    return <li>No active equity found</li>;
                                                })()}
                                            </ul>
                                        </div>
                                    )}
                                </div>
                                {/* <div className="mb-3">
                                    <label className="form-label small text-muted">
                                        <i className="bi bi-chat-left-text me-1"></i>
                                        Remarks
                                    </label>
                                    <textarea
                                        className="form-control"
                                        rows="3"
                                        placeholder="Add any notes or remarks..."
                                        value={paymentData.remarks}
                                        onChange={(e) => setPaymentData({
                                            ...paymentData,
                                            remarks: e.target.value
                                        })}
                                    />
                                </div> */}
                            </div>
                            <div className="modal-footer border-0 pt-0">
                                <button
                                    type="button"
                                    className="btn btn-light"
                                    onClick={() => {
                                        setPaymentModal(false);
                                        setPaymentData({
                                            total_profit: "",
                                            distributed_amount: "",
                                            profit_month: "",
                                            remarks: "",
                                        });
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-success d-flex align-items-center gap-2"
                                    onClick={handlePaymentSubmit}
                                >
                                    {/* <i className="bi bi-check-circle"></i> */}
                                    Payment
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* ADD / EDIT MODAL */}
            {showModal && (
                <AddShareHolderForm
                    data={selectedData}
                    closeModal={() => setShowModal(false)}
                    refreshList={fetchData}
                />
            )}
        </div>
    );
};

export default ShareHolderList;


